import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

export const getErrorMessage = (error: FetchBaseQueryError | SerializedError | undefined): string | null => {
        if (!error) return null;

        if ('status' in error) {
            return typeof error.data === 'string'
                ? error.data
                : JSON.stringify(error.data);
        }

        return error.message ?? 'An unknown error occurred';
    };